export default __webpack_public_path__ + "static/media/Impact of Lunar Eclipse on Zodiac Signs (2).244425f8.png";